// Multi-language resource loader
/// <reference types="vite/client" />

// Import all translation files dynamically
const modules = import.meta.glob('../locales/*/*.ts', { eager: true });

const messages: Record<string, Record<string, Record<string, string>>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\.\/locales\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as { default?: Record<string, string> };
    
    if (!messages[lang]) {
      messages[lang] = {};
    }
    
    if (!messages[lang][namespace]) {
      messages[lang][namespace] = {};
    }
    
    // Merge translation content by namespace
    if (module.default) {
      messages[lang][namespace] = {
        ...messages[lang][namespace],
        ...module.default
      };
    }
  }
});

export default messages; 